import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthService } from '@core/auth/auth.service';

export const authenticatedGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);

  if (authService.isUserCurrentlyLoggedIn()) {
    return true;
  }

  authService.beginLoginRedirect(state.url);
  return false;
};
